#import "@core/schema/fragments/CouponFull.graphql";

query (
  $code: String!
) {
  validateCoupon(
    code: $code
  ) {
    ...CouponFull
  }
}
